import { useContext, useState } from "react"
import { useParams, useNavigate, Link } from "react-router-dom"
import { useQuery } from "@apollo/client"
import _ from "lodash"
import { DateTime } from "luxon"
import {
  GET_SERVICE_EPISODE,
  GET_SERVICE_EPISODE_BY_EPISODE_NUMBER,
} from "./queries"
import { UserContext } from "../../context/userContext"

import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { Button } from "primereact/button"
import { SplitButton } from "primereact/splitbutton"

// Comps
import LoaderFullPage from "../../components/Loaders"
import ParticipantSidebar from "../../components/sidebars/ParticipantSidebar"
import PageSidebarContent from "../../components/sidebars/PageSidebarContent"

import styles from "../../styles/Page-Engagements.module.css"
import { navigateWithOrigin } from "../../helpers/navigation"

export default function ServicesEpisode() {
  const [serviceEpisode, setServiceEpisode] = useState(null)
  const userCtx = useContext(UserContext)
  const navigate = useNavigate()
  const { service_episode_id } = useParams()

  const convertDate = (date) => {
    const parsedDate = DateTime.fromISO(date)
    return parsedDate.toFormat("MM/dd/yyyy")
  }

  const { loading: loadingMaxServiceEpisode } = useQuery(
    GET_SERVICE_EPISODE_BY_EPISODE_NUMBER,
    {
      variables: {
        participant_id: userCtx.participant_id,
        organization_id: userCtx.session.user.organization_id,
        staff_id: userCtx.session.user.staff_id,
        participant_membership_id: userCtx.participant_membership_id,
        episode_number: service_episode_id,
      },
      fetchPolicy: "network-only",
      skip: !userCtx.participant_id,
      onCompleted: async (data) => {
        if (data.getServiceEpisodebyEpisodeNumber === null) {
          return setServiceEpisode(null)
        }
        const episodesList = data?.getServiceEpisodebyEpisodeNumber || []

        const handleData = _.map(episodesList, (episode) => {
          const viewIntake = episode.episode_code_id === "100"
          const viewDischarge = episode.episode_code_id === "200"

          const editIntake =
            episode.episode_code_id === "100" &&
            userCtx.session.user.staff_role < 6

          const viewServiceRecord = _.includes(
            ["101", "102", "103", "104", "105", "106"],
            episode.episode_code_id
          )
          let actionButton
          if (viewIntake) {
            if (editIntake) {
              actionButton = (
                <Button
                  label="View"
                  onClick={() => {
                    userCtx.changeParticipant(episode.participant_id)
                    navigateWithOrigin(
                      navigate,
                      `/form/view/${episode.template_name}/${
                        episode.episode_intake_uid ||
                        episode.manage_services_uid
                      }`
                    )
                  }}
                />
              )
            } else {
              actionButton = (
                <Button
                  label="View"
                  to={`/form/${episode.idTemplate}/1/session.values.idStamp}`}
                  onClick={() => {
                    userCtx.changeParticipant(episode.participant_id)
                    navigateWithOrigin(
                      navigate,
                      `/form/view/${episode.idTemplate}/${episode.idStamp}`
                    )
                  }}
                />
              )
            }
          }

          if (viewServiceRecord) {
            actionButton = (
              <Button
                label="View"
                onClick={() => {
                  userCtx.changeParticipant(episode.participant_id)
                  navigateWithOrigin(
                    navigate,
                    `/form/view/manage_services/${episode.manage_services_uid}`
                  )
                }}
              />
            )
          }

          if (viewDischarge) {
            actionButton = (
              <Button
                label="View"
                onClick={() => {
                  navigateWithOrigin(
                    navigate,
                    `/form/view/discharge_session/${episode.episode_discharge_uid}`
                  )
                }}
              />
            )
          }

          let date

          if (!_.isNull(episode?.episode_intake_date)) {
            date = episode?.episode_intake_date
          } else if (!_.isNull(episode?.manage_services_date)) {
            date = episode?.manage_services_date
          } else if (!_.isNull(episode?.episode_discharge_date)) {
            date = episode?.episode_discharge_date
          }

          let episode_name = ""
          let detailEpisode = ""
          switch (episode?.episode_code_id) {
            case "100":
              episode_name = "Service Episode Start"
              detailEpisode = "Intake Session"
              break
            case "101":
              episode_name = "Program ID Change"
              detailEpisode = episode?.program_ids
              break
            case "102":
              episode_name = "Staff Assignment Change"
              detailEpisode = episode?.staff_ids
              break
            case "103":
              episode_name = "Location ID Change"
              detailEpisode = episode?.location_ids
              break
            case "104":
              episode_name = "External ID Change"
              detailEpisode = episode?.external_ids
              break
            case "105":
              episode_name = "Share Participant Record"
              break
            case "106":
              episode_name = "Transfer Participant Record"
              break
            case "200":
              episode_name = "Service Episode End"
              detailEpisode = "Discharge Session"
              break

            default:
              break
          }
          return {
            date: convertDate(date),
            manage_services_date: episode?.manage_services_date,
            episode_code_id: episode_name,
            program_ids: episode?.program_ids,
            staff_ids: episode?.staff_ids,
            location_ids: episode?.location_ids,
            edit: actionButton,
            detailEpisode: detailEpisode,
          }
        })
        setServiceEpisode(handleData)
      },
    }
  )

  const loading = loadingMaxServiceEpisode

  if (loading) return <LoaderFullPage />

  return (
    <>
      <PageSidebarContent>
        <ParticipantSidebar />
      </PageSidebarContent>
      <div className="main-content">
        <div>
          <div>
            <h1 className={styles.title}>Service Episode</h1>
            <Link className="btn-sm mb-5" onClick={() => navigate(-1)}>
              Go Back
            </Link>

            <DataTable
              value={serviceEpisode}
              responsiveLayout="scroll"
              className="mb-5"
            >
              <Column field="date" header="Service Date" />
              <Column field="episode_code_id" header="Service Type" />
              {/*  <Column field="program_ids" header="Program ID Assign" />
              <Column field="staff_ids" header="Staff Assign" />
              <Column field="location_ids" header="Location Assign" />*/}
              <Column field="detailEpisode" header="Service Detail" />
              <Column field="edit" header="Actions" />
            </DataTable>
          </div>
        </div>
      </div>
    </>
  )
}
